import React, { useEffect, useState, useMemo } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { DataGrid, SelectColumn } from 'react-data-grid';

function rowKeyGetter(row) {
  return row.id;
}

function getComparator(sortColumn) {
  switch (sortColumn) {
    case 'email':
    case 'name':
      return (a, b) => {
        return a[sortColumn].localeCompare(b[sortColumn]);
      };
    default:
      throw new Error(`unsupported sortColumn: "${sortColumn}"`);
  }
}

function UserDialog({ open, users, onClose }) {
  const [userRows, setUserRows] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState(new Set());
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sortColumns, setSortColumns] = useState([]);

  useEffect(() => {
    setUserRows(users);
  }, [users]);

  const onUserSelected = (ids) => {
    let users = userRows.slice();
    users.map((user) => {
      if (ids.has(user.id)) {
        user.isSelected = true;
      } else {
        user.isSelected = false;
      }
      return user;
    });

    let selected_users = [];
    for (const user of users) {
      if (user.isSelected) selected_users.push(user);
    }
    setSelectedUserIds(ids);
    setUserRows(users);
    setSelectedUsers(selected_users);
  };

  const userDialogcolumns = [
    SelectColumn,
    {
      key: 'email',
      name: 'User Email',
      sortable: true,
    },
    {
      key: 'name',
      name: 'User Name',
      sortable: true,
    },
  ];

  const sortedRows = useMemo(() => {
    if (sortColumns.length === 0) return userRows;

    return [...userRows].sort((a, b) => {
      for (const sort of sortColumns) {
        const comparator = getComparator(sort.columnKey);
        const compResult = comparator(a, b);
        if (compResult !== 0) {
          return sort.direction === 'ASC' ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [userRows, sortColumns]);

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Add users to the role</DialogTitle>
      <DialogContent>
        <DialogContentText>
          To add users to the role, please select users to add.
        </DialogContentText>
      </DialogContent>
      <DataGrid
        className="rdg-light"
        rowKeyGetter={rowKeyGetter}
        columns={userDialogcolumns}
        rows={sortedRows}
        sortColumns={sortColumns}
        onSortColumnsChange={setSortColumns}
        selectedRows={selectedUserIds}
        onSelectedRowsChange={onUserSelected}
      />
      <DialogActions>
        <Button onClick={() => onClose()} variant="contained">
          Cancel
        </Button>
        <Button
          onClick={() => onClose(selectedUsers)}
          variant="contained"
          color="primary"
          style={{ backgroundColor: '#1976D2', color: 'white' }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UserDialog;
